module.exports = __webpack_public_path__ + "img/GoldenRoseCC_EGM.e570cb63.jpg";